/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Custom content section for challenge pages. Supports HTML content or embedded widgets.
 * @export
 * @interface ChallengeContentSection
 */
export interface ChallengeContentSection {
    /**
     * HTML content to render
     * @type {string}
     * @memberof ChallengeContentSection
     */
    content?: string;
    /**
     * Width of section as percentage (0-100)
     * @type {number}
     * @memberof ChallengeContentSection
     */
    widthPercentage?: number;
}

/**
 * Check if a given object implements the ChallengeContentSection interface.
 */
export function instanceOfChallengeContentSection(value: object): value is ChallengeContentSection {
    return true;
}

export function ChallengeContentSectionFromJSON(json: any): ChallengeContentSection {
    return ChallengeContentSectionFromJSONTyped(json, false);
}

export function ChallengeContentSectionFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChallengeContentSection {
    if (json == null) {
        return json;
    }
    return {
        
        'content': json['content'] == null ? undefined : json['content'],
        'widthPercentage': json['widthPercentage'] == null ? undefined : json['widthPercentage'],
    };
}

export function ChallengeContentSectionToJSON(json: any): ChallengeContentSection {
    return ChallengeContentSectionToJSONTyped(json, false);
}

export function ChallengeContentSectionToJSONTyped(value?: ChallengeContentSection | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'content': value['content'],
        'widthPercentage': value['widthPercentage'],
    };
}

